import { Link } from 'react-router-dom';
import '../styles/pages/DashboardPage.css';
import { FaFileInvoice, FaImage, FaBook, FaBalanceScale, FaClipboardList, FaRobot, FaFileAlt, FaReceipt, FaCashRegister, FaLock, FaUsers, FaBuilding, FaCreditCard } from 'react-icons/fa';
const DashboardPage = ({ company }) => {
  return (
    <div className="dashboard-page">
      <h1>Dashboard de {company.name}</h1>
      <div className="dashboard">
        <Box title="Compras">
            <Card title="Carga facturas compra" link="/carga-compras" icon={<FaFileInvoice />} />
            <Card title="Carga Imágenes boletas" link="/cargar-imagen" icon={<FaImage />} />
        </Box>
        <Box title="Ventas">
            <Card title="Carga facturas ventas" link="/carga-ventas" icon={<FaFileAlt />} />
            <Card title="Carga Boletas" link="/cargar-boletas-sii" icon={<FaReceipt />} />
            <Card title="Carga ventas POS" link="/comprobante-pago" icon={<FaCashRegister />} />
        </Box>
        <div className="column">
          <Card title="Ingreso asientos" link="/ingreso-manual" icon={<FaBook />} />
          <Card title="Visualizar balance" link="/ver-balance" icon={<FaBalanceScale />} />
          <Card title="Cierre Mensual" link="/cierre-mensual" icon={<FaLock />} />
          <Card title="Cierre Anual" link="/cierre-anual" icon={<FaLock />} />
        </div>
        <div className="column">
          <Card title="Revisa gastos registrados mediante imagenes" link="/ver-gastos-pendientes" icon={<FaClipboardList />} />
          <Card title="Automatización SII" link="/servicios-sii" icon={<FaRobot />} />
          <Card title="Arriendos" link="/arriendos" icon={<FaBuilding />} />
          <Card title="Recursos Humanos" link="/rrhh" icon={<FaUsers />} />
          <Card title="Configurar Medios de Pago" link="/credenciales-medios-pago" icon={<FaCreditCard />} />
        </div>
      </div>
    </div>
  );
};
const Box = ({ title, children }) => (
  <div className="box">
    <h2 className="box-title">{title}</h2>
    {children}
  </div>
);
const Card = ({ title, link, icon }) => {
  return (
    <div className="card">
      <div className="card-icon">{icon}</div>
      <Link to={link}>{title}</Link>
    </div>
  );
};

export default DashboardPage;

